export const DEFAULT_BRAND = {
  agencyName: "your CRM",
  logoUrl: "/fieldflow-logo.png",
};

export const brandMixin = {
  inject: {
    brand: {
      from: "brand",
      default: () => ({ ...DEFAULT_BRAND }),
    },
  },
};
